/* ----------------------------------------------------------------------------------------------------------------
   RECHARGE-STYLE SUBSCRIBE & SAVE CARD — JS
   ----------------------------------------------------------------------------------------------------------------
   Add this to your theme's main JS asset file (e.g. theme.js / global.js), NOT inline per-card,
   so listeners are only attached once for the whole page.

   Uses event.composedPath() so it still works if product-card is an OPEN shadow-DOM web component.
   If product-card uses a CLOSED shadow root, this file cannot reach inside it — in that case the
   listeners need to be added inside the component's own connectedCallback() instead.
---------------------------------------------------------------------------------------------------------------- */

(function () {
  function findInPath(event, className) {
    const path = event.composedPath();
    return path.find(function (el) {
      return el.classList && el.classList.contains(className);
    });
  }

  function formatMoney(cents) {
    // Replace with Shopify.formatMoney(cents, format) if your theme exposes it,
    // so currency symbol/decimal formatting matches your store locale (e.g. EUR).
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // FREQUENCY CHANGE HANDLER
  document.addEventListener('change', function (e) {
    const select = findInPath(e, 'rc-frequency-select');
    if (!select) return;

    const card = findInPath(e, 'rc-subscribe-card');
    if (!card) return;

    const option = select.options[select.selectedIndex];
    const price = option.dataset.price;
    const compareAt = option.dataset.compareAt;

    const priceEl = card.querySelector('.rc-current-price');
    let compareEl = card.querySelector('.rc-compare-price');

    if (priceEl) {
      priceEl.textContent = formatMoney(price);

      if (Number(compareAt) > Number(price)) {
        if (compareEl) {
          compareEl.textContent = formatMoney(compareAt);
        } else {
          compareEl = document.createElement('s');
          compareEl.className = 'rc-compare-price';
          compareEl.textContent = formatMoney(compareAt);
          priceEl.parentNode.insertBefore(compareEl, priceEl);
        }
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    // .price-list lives in a sibling block (.product-card__info), NOT inside
    // .rc-subscribe-card — so we search from the shared <product-card> root instead.
    const cardRoot = card.closest('product-card') || card.closest('.product-card') || card.parentElement;
    const priceList = cardRoot ? cardRoot.querySelector('.price-list') : null;

    if (priceList) {
      const saleMoneyEl = priceList.querySelector('sale-price .glc-money');
      let compareAtPriceEl = priceList.querySelector('compare-at-price');

      if (saleMoneyEl) {
        saleMoneyEl.textContent = formatMoney(price);
      }

      if (Number(compareAt) > Number(price)) {
        if (!compareAtPriceEl) {
          // compare-at-price doesn't exist yet (this product currently has no discount
          // in the page's initial render) — build it to match the theme's markup.
          compareAtPriceEl = document.createElement('compare-at-price');
          compareAtPriceEl.className = 'text-subdued line-through';
          compareAtPriceEl.innerHTML =
            '<span class="sr-only">Regular price</span>' +
            '<span class="glc-money" translate="no"></span>';
          priceList.appendChild(compareAtPriceEl);
        }
        const compareMoneyEl = compareAtPriceEl.querySelector('.glc-money');
        if (compareMoneyEl) {
          compareMoneyEl.textContent = formatMoney(compareAt);
        }
        compareAtPriceEl.style.display = '';
      } else if (compareAtPriceEl) {
        compareAtPriceEl.style.display = 'none';
      }
    }

    // Store selected selling plan on the card so the subscribe click can read it
    card.dataset.selectedSellingPlan = select.value;
  });

  function tryOpenCartDrawer(data) {
    // Try several common Shopify theme patterns — keep whichever one actually
    // works for this theme and remove the rest once confirmed.

    // Pattern 1: custom event most themes listen for
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));

    // Pattern 2: a <cart-drawer> custom element with an .open() method
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
      return;
    }

    // Pattern 3: a cart icon/toggle button that opens the drawer when clicked
    var cartToggle = document.querySelector('[data-cart-drawer-toggle], #cart-icon-bubble, .header__icon--cart');
    if (cartToggle) {
      cartToggle.click();
      return;
    }

    // Pattern 4: Shopify's Section Rendering API refresh, if the theme exposes it
    if (window.Shopify && window.Shopify.onCartUpdate) {
      window.Shopify.onCartUpdate(data);
    }
  }

  // SUBSCRIBE BUTTON CLICK HANDLER
  document.addEventListener('click', function (e) {
    const button = findInPath(e, 'rc-subscribe-button');
    if (!button) return;

    const card = findInPath(e, 'rc-subscribe-card');
    if (!card) return;

    const variantId = card.dataset.variantId;
    const select = card.querySelector('.rc-frequency-select');
    const sellingPlanId = select ? select.value : '';

    button.disabled = true;

    // Trigger the theme's native loading-bar progress indicator
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    const item = {
      id: variantId,
      quantity: 1
    };

    // Only attach selling_plan when a real plan is selected.
    // Empty string ("One-time") means a normal one-time purchase —
    // Shopify's cart API rejects/ignores selling_plan: "" inconsistently,
    // so we omit the key entirely instead of sending it empty.
    if (sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    const body = {
      items: [item]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        // Adjust this event name to match whatever your theme's cart drawer listens for,
        // so the drawer opens automatically after subscribing.
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        tryOpenCartDrawer(data);
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
      })
      .finally(function () {
        button.disabled = false;
        // Stop the theme's loading-bar regardless of success/failure
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  });
})();